import { render, staticRenderFns } from "./pathplan2.vue?vue&type=template&id=037ac1e0&scoped=true&"
import script from "./pathplan2.vue?vue&type=script&lang=js&"
export * from "./pathplan2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ac1e0",
  null
  
)

export default component.exports